import * as $ from 'jquery';
import * as i18n from 'CMS/core/i18n';

export default class MenuPart {
    constructor() {
    }

    public initialize(options: any) {
        var $root = $(options.root);
        /* prevent close of megamenu on click */
        $root.on('click', '.dropdown.open .megamenu', (e) => { e.stopPropagation(); });

        $root.find('.navbar-collapse').on('show.bs.collapse', () => {
            $('body').addClass('menu-open');
        });
        $root.find('.navbar-collapse').on('hidden.bs.collapse', () => {
            $('body').removeClass('menu-open');
        });

        var $myshipsPlaceholder = $root.find('.myships-placeholder');
        if ($myshipsPlaceholder.length) {
            import('visuris/Data/Repositories/ShipLinkRepository').then((ShipLinkRepositoryModule: any) => { // tslint:disable-line
                var ShipLinkRepository = ShipLinkRepositoryModule.default; // tslint:disable-line
                var shipRepository = new ShipLinkRepository();

                var $shipLinks = $();
                shipRepository.getShipLinkPagesForUser().then((linkPages: any) => {
                    if (linkPages != null && linkPages.pages != null && linkPages.pages.length) {
                        for (let i = 0; i < linkPages.pages.length; i++) {
                            $shipLinks = $shipLinks.add('<li><a href="' + linkPages.pages[i].value + '">' + linkPages.pages[i].key + '</a></li>');
                        }
                        if (linkPages !== undefined && linkPages.more != null && linkPages.more !== '') {
                            $shipLinks = $shipLinks.add('<li><a href="' + linkPages.more + '">' + i18n.getMessage('general.morePages') + ' <span class="vi vi-angle-right vi-10px"></span></a></li>');
                        }
                        $myshipsPlaceholder.replaceWith($shipLinks);
                    }
                });
            });
        }

        var $myobjectsPlaceholder = $root.find('.myobjects-placeholder');
        if ($myobjectsPlaceholder.length) {
            import('visuris/Data/Repositories/ObjectLinkRepository').then((ObjectLinkRepositoryModule: any) => { // tslint:disable-line
                var ObjectLinkRepository = ObjectLinkRepositoryModule.default; // tslint:disable-line
                var objectLinkRepository = new ObjectLinkRepository();

                var $objectLinks = $();
                objectLinkRepository.getObjectLinkPagesForUser().then((linkPages: any) => {
                    if (linkPages != null && linkPages.pages != null && linkPages.pages.length) {
                        for (let i = 0; i < linkPages.pages.length; i++) {
                            $objectLinks = $objectLinks.add('<li><a href="' + linkPages.pages[i].value + '">' + linkPages.pages[i].key + '</a></li>');
                        }
                        if (linkPages !== undefined && linkPages.more != null && linkPages.more !== '') {
                            $objectLinks = $objectLinks.add('<li><a href="' + linkPages.more + '">' + i18n.getMessage('general.morePages') + ' <span class="vi vi-angle-right vi-10px"></span></a></li>');
                        }
                        $myobjectsPlaceholder.replaceWith($objectLinks);
                    }
                });
            });
        }
    }

    public destroy() {
    }

}